import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// Export routes for standalone bootstrapping in main.ts
export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./features/home/home.module").then((m) => m.HomeModule),
    pathMatch: "full",
  },
  {
    path: "call-in-progress",
    loadChildren: () =>
      import("./features/call-in-progress/call-in-progress.module").then(
        (m) => m.CallInProgressModule,
      ),
  },
  {
    path: "call-transcript",
    loadChildren: () =>
      import("./features/call-transcript/call-transcript.module").then(
        (m) => m.CallTranscriptModule,
      ),
  },
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledBlocking",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
